import React from "react"
import styled from "styled-components"
import { graphql, useStaticQuery, Link } from "gatsby"
import _chunk from "lodash.chunk"

//@ts-ignore
import arrowLeftPurple from "../../../assets/arrowLeftPurple.svg"

//@ts-ignore
import arrowRightPurple from "../../../assets/arrowRightPurple.svg"
const FooterSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 60px;
  background-color: ${p => (p.bgC ? p.bgC : " #f2dec3")};
`

const WordBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .contributeButton {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    width: 250px;
    height: 48px;
    margin-top: 36px;
    background-color: #f2dec3;
    border: 1px solid #ac987c;
    font-size: 18px;
    font-weight: 700;
    font-family: "Tinos", serif;
    color: #6b3e7d;
  }
  .view {
    margin-top: 8px;
    text-decoration: none;
    font-size: 0.8rem;
    color: #424242;
  }
  h2 {
    font-size: 18px;
    font-weight: 700;
    font-family: "Amasis", serif;
    max-width: 622px;
    text-align: center;
  }
  img {
    margin-top: 5px;
    width: 100%;
  }
  @media screen and (max-width: 820px) {
    h2 {
      font-size: 16px;
    }
  }
  @media screen and (max-width: 651px) {
    h2 {
      margin-bottom: 10px;
    }
  }
  @media screen and (max-width: 440px) {
    h2 {
      font-size: 13px;
    }
  }
`
const ContributorBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`
const ContributorColumn = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-family: Cabin;
  margin-right: 50px;
  color: black;
  margin-top: 10px;

  @media screen and (max-width: 820px) {
    font-size: 10px;
  }
  @media screen and (max-width: 651px) {
    margin-top: 0;
    font-size: 14px;
    margin-right: 0;
  }
  @media screen and (max-width: 440px) {
    font-size: 12px;
  }
`
const ContributorRow = styled.div`
  display: flex;
  flex-direction: row;
  @media screen and (max-width: 651px) {
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
`
const Bottom = styled.div`
  margin-top: 200px;
  height: 60px;
  width: 100%;
  background-color: #dac6ac;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  span {
    font-size: 18px;
    font-family: "Tinos", serif;
    font-weight: 700;
    font-style: italic;
    color: #6b3e7d;
  }
  h2 {
    font-size: 22px;
    font-family: "Amasis", serif;
    font-weight: 700;
    color: #250532;
  }
  img {
    margin-bottom: 1px;
  }
  .left {
    margin-right: 10px;
  }
  .right {
    margin-left: 10px;
  }

  @media screen and (max-width: 820px) {
    h2 {
      font-size: 18px;
    }
    span {
      font-size: 14px;
    }
  }
  @media screen and (max-width: 651px) {
    h2 {
      font-size: 16px;
    }
    span {
      font-size: 12px;
    }
  }
  @media screen and (max-width: 440px) {
    justify-content: space-around;
    margin-top: 100px;
    h2 {
      font-size: 13px;
    }
    span {
      font-size: 10px;
    }
    img {
      margin-bottom: 0;
    }
  }
`
const CheatWrapper = styled.div`
  max-width: 1040px;
  @media screen and (max-width: 820px) {
    max-width: 600px;
  }
  @media screen and (max-width: 651px) {
    max-width: 400px;
  }
  @media screen and (max-width: 440px) {
    max-width: 300px;
  }
`
const FooterArea: React.FC<{}> = function () {
  const { allContentfulFolioLaunch } = useStaticQuery(graphql`
    query FooterFolioContent {
      allContentfulFolioLaunch {
        edges {
          node {
            issuLink
            id
            backgroundColor
            title
            contributors
            contributorDescription {
              contributorDescription
            }
          }
        }
      }
    }
  `)

  const firstNode = allContentfulFolioLaunch.edges[0]
  const chunkedContributors = _chunk(firstNode.node.contributors, 5)
  return (
    <FooterSection bgC={firstNode.node.backgroundColor}>
      <CheatWrapper>
        <WordBox>
          <h2>
            {firstNode.node.contributorDescription.contributorDescription}
          </h2>
          <ContributorBox>
            <ContributorRow>
              {chunkedContributors.map(el => {
                return (
                  <ContributorColumn>
                    {el.map(el => (
                      <span>{el.toUpperCase()}</span>
                    ))}
                  </ContributorColumn>
                )
              })}
            </ContributorRow>
          </ContributorBox>
          <Link className="contributeButton" to="/contribute">
            {" "}
            Contribute for Upcoming +
          </Link>
          <a className="view" href={firstNode.node.issuLink} target="_blank">
            View this Folio on Issuu
          </a>
        </WordBox>
      </CheatWrapper>
      <Bottom>
        <h2>{firstNode.node.title}</h2>
      </Bottom>
    </FooterSection>
  )
}

export default FooterArea
